import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircledCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.748 12.000 A11.250 11.250 0 1 0 23.248 12.000 A11.250 11.250 0 1 0 0.748 12.000 Z",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.498 16.5L16.497 7.5",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.498 16.5L7.497 7.5",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgCircledCross;
